import React from "react";
import {
  Paper,
  createStyles,
  TextInput,
  PasswordInput,
  Checkbox,
  Button,
  Title,
  Text,
  Anchor,
  Container,
  Group,
  Grid,
} from "@mantine/core";

import { useTranslation } from "react-i18next";
import { useForm } from "@mantine/form";
import { useServerApi } from "../hooks/userServerApi";
import { showNotification } from "@mantine/notifications";
import { IconExclamationMark, IconCircleCheck } from "@tabler/icons";
import {
  useSignIn,
  useIsAuthenticated,
  useSignOut,
  useAuthUser,
} from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import { FormPage, FormSectionCard, useFormNotification } from "../layout/page";

import _ from "lodash";

const ResetPassword = () => {
  const title = "Settings > Password";
  const [api] = useServerApi();
  const signOut = useSignOut();
  const auth = useAuthUser();
  const [notifyFormSuccess, notifyFormError] = useFormNotification();

  const form = useForm({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      newPassword2: "",
    },

    validate: {
      oldPassword: (value) =>
        value === "" ? "Please fill in existing password" : null,

      newPassword: (value) =>
        value?.length < 5 ? "Password length must larger than 5" : null,

      newPassword2: (value, values) =>
        value !== values.newPassword ? "Confirm password not match" : null,
    },
  });

  const handleSubmit = async () => {
    // console.log("Submit", form.values);
    try {
      const validation = form.validate();
      if (validation.hasErrors) return;

      const result = await api.User.changePassword({
        ...form.values,
        id: auth().id,
      });

      const { success, error } = result;

      if (!success) {
        return notifyFormError({
          title: "Change Password Fail",
          message: error,
        });
      }

      signOut();
      notifyFormSuccess({
        title: "Change Password Success",
        message: "Your account will be logout.",
      });
    } catch (error) {
      console.log(error);
    }
  };

  const actions = () => {
    return (
      <Group>
        <Button onClick={handleSubmit}>{t("Save")}</Button>
      </Group>
    );
  };

  const { t } = useTranslation();
  return (
    <FormPage title={t(title)} actions={actions}>
      <FormSectionCard title={t("Reset your password")}>
        <PasswordInput
          label={t("Old Password")}
          placeholder={t("Your old password")}
          required
          mt="md"
          variant="filled"
          sx={{ border: 0 }}
          {...form.getInputProps("oldPassword")}
        />

        <PasswordInput
          label={t("New Password")}
          placeholder={t("Your new password")}
          required
          mt="md"
          variant="filled"
          {...form.getInputProps("newPassword")}
        />
        <PasswordInput
          label={t("Confirm Password")}
          placeholder={t("Your new password")}
          required
          mt="md"
          mb="md"
          variant="filled"
          {...form.getInputProps("newPassword2")}
        />
      </FormSectionCard>
    </FormPage>
  );
};

export default ResetPassword;
